module.exports = __webpack_public_path__ + "static/img/zryh.a650696.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zryh.png
// module id = M3Fn
// module chunks = 0